import Dialog from "componentsv2/modal/Dialog";
import BoardForm from "componentsv2/form/BoardForm";

/**
 *
 * @param {object} props - component props
 * @param {object} props.layout - object for render record
 * @param {object} props.onClose - object record to show
 * @param {boolean} props.open - true or false
 * @return {Component} - Modal Form for show form record
 */
function ModalForm({
  storeId,
  layout,
  openModal,
  onClose,
  parentRec,
  fieldName,
  size,
  refetch,
  reload,
}) {
  if (!layout) return null;

  async function handleClose(mustReload) {
    if (mustReload?.value && typeof reload === "function") {
      console.log(
        "Is necessary reload form or only parent???",
        mustReload.value,
      );
      reload();
    }

    await onClose(mustReload?.value);
    // if (reloadId) {
    //   reloadId.value++;
    // }
  }

  function getButtons() {
    const buttons = new Map();
    for (const [btnName, btnField] of Object.entries(layout.fields)) {
      if (btnField.type === "button") {
        buttons.set(btnName, {
          name: btnName,
          label: btnField.label,
          onClick: btnField.method,
          color: btnField.color,
        });
      }
    }
    return buttons;
  }

  const actionButtons = getButtons();
  return (
    <Dialog
      id="modal-form"
      size={size || "w-2/3 max-h-[90vh] 2xl:w-3/4"}
      openModal={openModal}
      handleClose={handleClose}
      buttons={null}
      title={layout.model}
      fixedHeight={true}
    >
      <BoardForm
        storeId={storeId}
        layout={layout}
        onClose={handleClose}
        parentRec={parentRec}
        fieldName={fieldName}
        actionButtons={actionButtons}
        view="modal"
        refetch={refetch}
        // recordId={recordId}
      />
    </Dialog>
  );
}

export default ModalForm;
